/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Surcharge/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function Surcharge({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation/PlatformFeeWarning/Content/AcknowledgementText/Card/Surcharge"
  
}) {
let paymentCardFeePercentValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
path: 'card_fee_percent',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 data="payment.card_fee_percent"
 format="helpers.js getText"
 text={paymentCardFeePercentValueData}
/>
{children}
</React.Fragment>)
}